import FaqQuestion from "./FaqQuestion";
import QUESTIONS from "../lib/questions";
import React from "react";

export default class Faq extends React.PureComponent {
  static seeMore () {
    return (
      <div className="center small mt8 pt4">
        <a
          href="/faq"
          id="faq-see-more-link"
        >
          See more
          {" >"}
        </a>
      </div>
    );
  }

  constructor (props) {
    super(props);
    this.state = QUESTIONS;
  }

  questions () {
    const {questions} = this.state;
    return (
      questions.map((question, questionIndex) => (
        <FaqQuestion
          answerContent={question.answer}
          index={questionIndex}
          key={question.question}
          questionContent={question.question}
        />
      ))
    );
  }

  render () {
    return (
      <div>
        <h2 className="styled_h5 center">
          FAQ
        </h2>
        {this.questions()}
        {this.constructor.seeMore()}
      </div>
    );
  }
}
